import { useState, useCallback, useLayoutEffect } from 'react';
import { FilterValue } from 'components/filtering/types/FilterObject';
import { CheckTypeEnum } from 'components/filtering/types/CheckTypeEnum';
import { FilterPopoverProps } from 'components/filtering/filter-popover/FilterPopover';



const useFilterPopover = (props: FilterPopoverProps) => {
	const { filterValues, onSearchValues, onAddFilterValues, onClear } = props;

	const [ searchText, setSearchText ] = useState<string>('');
	const [ addToFilter, setAddToFilter ] = useState(false);
	
	const [ filteredFilterValues, setFilteredFilterValues ] = useState<FilterValue[]>([]);
	const [ filteredValuesCheckType, setFilteredValuesCheckType ] = useState<CheckTypeEnum>(CheckTypeEnum.none);
	

	useLayoutEffect(() => {
		if (!searchText || searchText.length === 0) {
			let copyFilterValues = filterValues.map(x => ({...x}));
			setFilteredFilterValues(copyFilterValues);
			return;
		}
		let normalizedSearchText = searchText.toLowerCase();
		let filteredValues = filterValues.filter(x => String(x.value).toLowerCase().includes(normalizedSearchText));
		let copyFilteredValues = filteredValues.map(x => ({...x, checked: true }));
		setFilteredFilterValues(copyFilteredValues);
	}, [ filterValues, searchText ]);


	useLayoutEffect(() => {
		let isAllCheck = true;
		let isAllUncheck = true;

		for (const value of filteredFilterValues) {
			if (value.checked === false && isAllCheck === true) {
				isAllCheck = false;
			}
			if (value.checked === true && isAllUncheck === true) {
				isAllUncheck = false;
			}
		}

		if (isAllCheck) {
			setFilteredValuesCheckType(CheckTypeEnum.all);
			return;
		}
		if (isAllUncheck) {
			setFilteredValuesCheckType(CheckTypeEnum.none);
			return;
		}
		setFilteredValuesCheckType(CheckTypeEnum.some);
	}, [ filteredFilterValues ]);

	
	const handleToggle = useCallback((checkedValues: unknown[]) => {
		if (!filteredFilterValues || filteredFilterValues.length === 0 || !checkedValues || checkedValues.length === 0) return;

		let checkedValuesSet: Set<unknown> = new Set(checkedValues);
		let copyCheckedFilterValues = filteredFilterValues.map(x => checkedValuesSet.has(x.value)
			? ({ ...x, checked: !x.checked })
			: ({ ...x }));
			
		setFilteredFilterValues(copyCheckedFilterValues);
	},[ filteredFilterValues ]);


	const handleToggleAll = useCallback(() => {
		filteredValuesCheckType === CheckTypeEnum.all
		? setFilteredFilterValues(filteredFilterValues.map(x => ({ ...x, checked: false }) ))
		: setFilteredFilterValues(filteredFilterValues.map(x => ({ ...x, checked: true }) ));
	},[ filteredFilterValues, filteredValuesCheckType ]);

	
	const handleAddToFilter = useCallback(() => {
		setAddToFilter(!addToFilter);
	},[ addToFilter ]);


	const handleConfirm = useCallback(() => {
		if (searchText && searchText.length > 0 && addToFilter === false) {
			let checkedValues = filteredFilterValues.filter(x => x.checked === true).map(x => x.value);
			onSearchValues(checkedValues);
			document.body.click();
			return;	
		}
		
		onAddFilterValues(filteredFilterValues);
		document.body.click();
	},[ filteredFilterValues, searchText, addToFilter, onSearchValues, onAddFilterValues ]);

	
	const handleCancel = useCallback(() => {
		document.body.click();
	},[]);

	
	const handleClear = useCallback(() => {
		onClear();
		document.body.click();
	},[ onClear ]);

	
	return [ searchText, setSearchText, addToFilter, filteredFilterValues, filteredValuesCheckType,
		handleToggle, handleToggleAll, handleAddToFilter, handleConfirm, handleCancel, handleClear ] as const;
};

export default useFilterPopover;